import { EditorDataV2, Size } from '../types';
import { AnimationsTab, useAnimationsTab } from './AnimationsTab';
import { BoxSizeFitChecker, useBoxSizeFitChecker } from './BoxSizeFitChecker';
import { LocalPresets, useLocalPresets } from './LocalPresets';
import { OverlayTiming, useOverlayTiming } from './OverlayTiming';
import { useStylePersistor } from './StylePersistor';
import { StylePersistor } from './StylePersistor/types';
import { TextOverlayModalExtensions } from './types';

interface UseTextOverlayExtensionsConfig {
  context: {
    aspectRatio: number;
    baseTextValue: string;
    canvasSize: Size;
    draftEditorData: EditorDataV2;
    initialEditorData: EditorDataV2;
  };
  extensions: TextOverlayModalExtensions;
}

interface UseTextOverlayExtensions {
  animationsTabExtension?: AnimationsTab;
  boxSizeFitCheckerExtension?: BoxSizeFitChecker;
  localPresets?: LocalPresets;
  overlayTimingExtension: OverlayTiming;
  stylePersistorExtension: StylePersistor;
}

const useTextOverlayExtensions = (
  config: UseTextOverlayExtensionsConfig,
): UseTextOverlayExtensions => {
  const { context, extensions } = config;

  const {
    aspectRatio,
    baseTextValue,
    canvasSize,
    draftEditorData,
    initialEditorData,
  } = context;

  const animationsTabExtension = useAnimationsTab({
    canvasSize,
    draftEditorData,
    extensionConfig: extensions?.animationsTab,
  });

  const boxSizeFitCheckerExtension = useBoxSizeFitChecker({
    baseTextValue,
    canvasSize,
    draftEditorData,
    initialEditorData,
    extensionConfig: extensions?.boxSizeFitChecker,
  });

  const overlayTimingExtension = useOverlayTiming({
    extensionConfig: extensions?.overlayTiming,
  });

  const stylePersistorExtension = useStylePersistor({
    extensionConfig: extensions?.stylePersistor,
  });

  const localPresets = useLocalPresets({
    aspectRatio,
    extensionConfig: extensions?.localPresets,
  });

  return {
    animationsTabExtension,
    boxSizeFitCheckerExtension,
    localPresets,
    overlayTimingExtension,
    stylePersistorExtension,
  };
};

export default useTextOverlayExtensions;
